module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.consulta.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir ASO"
    },
    on: {
      "click": _vm.imprimirASO
    }
  })], 1)], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('b-table-simple', {
    staticClass: "table-v2",
    attrs: {
      "hover": "",
      "small": "",
      "responsive": "",
      "stacked": (this.device == 'xs')
    }
  }, [_c('b-thead', {
    attrs: {
      "head-variant": ""
    }
  }, [_c('b-tr', [_c('b-th', [_vm._v("EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("DATA")])], 1)], 1), _vm._v(" "), (_vm.formData) ? _c('b-tbody', _vm._l((_vm.formData.exames), function(consulta_exame, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', [_vm._v("\r\n            " + _vm._s(consulta_exame.exame.nome) + "\r\n            "), (consulta_exame.id_con_dem != '0') ? _c('span', {
      staticClass: "tp-exame-dem",
      staticStyle: {
        "font-size": "9pt"
      },
      attrs: {
        "title": "Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
      }
    }, [_c('br'), _vm._v("Exame "), _c('b', [_vm._v("demonstrativo")]), _vm._v(" na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(consulta_exame.id_con_dem))])]) : (consulta_exame.id_con_rea != '0') ? _c('span', {
      staticClass: "tp-exame-dem",
      staticStyle: {
        "font-size": "9pt"
      },
      attrs: {
        "title": "Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
      }
    }, [_c('br'), _vm._v("Exame "), _c('b', [_vm._v("reaproveitado")]), _vm._v(" na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(consulta_exame.id_con_rea))])]) : _vm._e()]), _vm._v(" "), _c('b-td', [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "placeholder": "dd/mm/aaaa",
        "value-format": "yyyy-MM-dd",
        "format": "dd/MM/yyyy",
        "disabled": _vm.formOption.empty == 1 || consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0,
        "title": (consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0 ? 'A data deste exame não pode ser alterado' : '')
      },
      model: {
        value: (consulta_exame.data),
        callback: function($$v) {
          _vm.$set(consulta_exame, "data", $$v)
        },
        expression: "consulta_exame.data"
      }
    })], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center mt-3 mb-2"
  }, [_c('el-checkbox', {
    attrs: {
      "checked": _vm.formOption.empty == 1
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.formOption.empty),
      callback: function($$v) {
        _vm.$set(_vm.formOption, "empty", $$v)
      },
      expression: "formOption.empty"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Imprimir ASO com a data dos exames em branco")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Salvar Alterações e Imprimir ASO"
    },
    on: {
      "click": _vm.imprimirASO
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f18e45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/configuracao/aso.vue
// module id = 1450
// module chunks = 45